export const dataHooks = {
    mainAction: 'composerheader-mainaction',
    backButton: 'composerheader-back',
    leftDivider: 'composerheader-leftdivider',
    rightDivider: 'composerheader-rightdivider',
    saveStatus: 'composerheader-savestatus',
};
//# sourceMappingURL=constants.js.map